export const streamTimeout = 1000 * 60 * 10;